import { Component, Element, Host, State, h } from '@stencil/core';
import { HTMLStencilElement } from '@stencil/core/internal';
import { Unsubscribe, store } from '@stencil/redux';
import { SigningMethod, SourceName } from '../../enums/const-enums';
import { RootState, initialStore } from '../../redux/store';
import { isLogin } from '../../utils/utils';

@Component({
  tag: 'rass-summary',
  styleUrl: 'rass-summary.scss',
  shadow: true,
})
export class RassSummary {
  @Element() element!: HTMLStencilElement;
  @State() assetsPath: string;
  @State() summaryHtml: string;
  @State() sourceName: SourceName;
  @State() activeSignMethod: SigningMethod;
  unsubscribe!: Unsubscribe;

  componentWillLoad(): void {
    store.setStore(initialStore);
    store.mapStateToProps(this, (state: RootState) => {
      const {
        config: { assetsPath, summary, sourceName },
        methods: { activeSignMethod },
      } = state;
      return {
        assetsPath,
        summaryHtml: summary,
        sourceName,
        activeSignMethod,
      };
    });
  }

  render(): void {
    return (
      <Host class="section-summary">
        <style>@import url({`'${this.assetsPath}css/rds-style.css'`});</style>
        <div class="rds-container body-width" role="form">
          <div
            class={
              isLogin() || !this.summaryHtml
                ? 'rds-display-none'
                : 'section-summary rds-row rds-justify-content-center'
            }
          >
            <rass-summary-content
              class="rds-col-12"
              summaryHtml={this.summaryHtml}
            />
          </div>
          <div
            class={
              isLogin() || !this.summaryHtml
                ? 'rds-display-none'
                : 'rds-margin-inline-50 rds-margin-block-150 rds-row rds-justify-content-center'
            }
          >
            <div class="border-bottom rds-col-12" />
          </div>
        </div>
      </Host>
    ) as void;
  }
}
